import script from "./payroll-comparison-report.vue?vue&type=script&setup=true&lang=js"
export * from "./payroll-comparison-report.vue?vue&type=script&setup=true&lang=js"

import "./payroll-comparison-report.vue?vue&type=style&index=0&id=1ad41d52&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ad41d52"]])

export default __exports__